// ISO country code -> name in the user's language (falls back to the code itself).
export const countryName = (intl, code) => {
    try {
        return new Intl.DisplayNames([intl.locale], {type: 'region'}).of(code) || code;
    } catch (e) {
        return code;
    }
};

export const countryNames = (intl, codes) => (codes || []).map(code => countryName(intl, code)).join(', ');

// "Russia (12), United States (3)" from {RU: 12, US: 3}, biggest first.
export const countryNamesWithCounts = (intl, byCountry) => Object.entries(byCountry || {})
    .sort((a, b) => b[1] - a[1])
    .map(([code, count]) => `${countryName(intl, code)} (${count})`)
    .join(', ');

// Countries from a DESTINATION_NOT_ALLOWED response body ({countries: [...]} or {country: "RU"}).
export const destinationCountries = data => data?.countries?.length ? data.countries : (data?.country ? [data.country] : []);
